
interface AppointmentResponseErrorDialogProps {
  message: string;
  onClose: () => void;
}

export function AppointmentResponseErrorDialog({ message, onClose }: AppointmentResponseErrorDialogProps) {
  if (!message) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/40 px-6">
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="appointment-response-error-title"
        className="w-full max-w-xl rounded-2xl bg-white p-8 shadow-[0_25px_55px_rgba(19,19,19,0.18)]"
      >
        <h2 id="appointment-response-error-title" className="text-2xl font-semibold text-slate-950">
          Fehler
        </h2>
        <p className="mt-4 break-words text-base leading-7 text-slate-600">{message}</p>
        <div className="mt-8 flex justify-end">
          <button
            onClick={onClose}
            className="rounded-xl bg-[#cbb58a] px-6 py-3 text-sm font-semibold text-white shadow-[0_10px_20px_rgba(203,181,138,0.24)] transition hover:bg-[#bca477]"
          >
            Schliessen
          </button>
        </div>
      </div>
    </div>
  );
}
